import { useRef, useState } from "react";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import SocialButton from "components/SocialButton";

const imageCasino = [
  {
    url: "/assets/casino-ag.png",
    link: "/lobby",
    name: "ag",
  },
  {
    url: "/assets/casino-bg.png",
    link: "/lobby",
    name: "big-dream",
  },
  {
    url: "/assets/casino-venus.png",
    link: "/lobby",
    name: "venus",
  },
  {
    url: "/assets/casino-sexy.png",
    link: "/lobby",
    name: "ae-sexy",
  },
  {
    url: "/assets/casino-vivo.png",
    link: "/lobby",
    name: "vivo",
  },
  {
    url: "/assets/casino-wm.png",
    link: "/lobby",
    name: "wm",
  },
  {
    url: "/assets/casino-dream.png",
    link: "/lobby",
    name: "dream",
  },
];

const HomeCasino = () => {
  const [showMaintenance, setShowMaintenance] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(3);
  const touchStartXRef = useRef<number | null>(null);
  const touchEndXRef = useRef<number | null>(null);

  const navigate = useNavigate();

  const goToPreviousSlide = () => {
    setCurrentSlide((prevSlide) =>
      prevSlide === 0 ? imageCasino.length - 1 : prevSlide - 1,
    );
  };

  const goToNextSlide = () => {
    setCurrentSlide((prevSlide) =>
      prevSlide === imageCasino.length - 1 ? 0 : prevSlide + 1,
    );
  };

  const handleTouchStart = (event: React.TouchEvent<HTMLDivElement>) => {
    touchStartXRef.current = event.touches[0].clientX;
    touchEndXRef.current = null;
  };

  const handleTouchMove = (event: React.TouchEvent<HTMLDivElement>) => {
    touchEndXRef.current = event.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (touchStartXRef.current === null || touchEndXRef.current === null) {
      return;
    }

    const swipeDistance = touchStartXRef.current - touchEndXRef.current;
    const minSwipeDistance = 50;

    if (Math.abs(swipeDistance) < minSwipeDistance) {
      return;
    }

    if (swipeDistance > 0) {
      goToNextSlide();
    } else {
      goToPreviousSlide();
    }
  };

  const handleClick = (casino: any) => {
    if (casino.name === "ae-sexy") {
      navigate(`/casino${casino.link}`);
    } else {
      setShowMaintenance(true);
    }
  };

  return (
    <div className="min-h-screen relative overflow-x-hidden">
      <Header />
      <div className="w-full h-10 md:block hidden" />
      <div className="container-fluid lobby-bg position-relative mx-auto mb-5 max-w-screen-xl px-2 sm:px-4">
        <div className="container mx-auto max-w-full overflow-hidden">
          <img
            src="/assets/common/btn-back.png"
            alt="Casino Game"
            className="flex justify-start md:mb-6 mb-3 cursor-pointer"
            onClick={() => navigate("/")}
          />

          <div className="flex justify-center md:mb-6 mb-3 md:mt-0 mt-8">
            <img
              src="/assets/casino-game.png"
              alt="Casino Game"
              className="h-12 sm:h-20 md:h-24 w-auto"
            />
          </div>
          <div className="casino-slider-container sm:py-6 md:py-8 mb-0 sm:mb-8 md:mb-10 overflow-hidden">
            {/* Slider Cards */}
            <div className="casino-slider-wrapper overflow-hidden">
              <div
                className="casino-cards-container flex justify-center items-center relative min-h-[350px] sm:min-h-[400px] md:min-h-[450px] lg:min-h-[500px] w-full"
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
              >
                {imageCasino.map((e, index) => {
                  const isActive = index === currentSlide;

                  // Calculate relative position for circular display
                  let relativeIndex = index - currentSlide;

                  // Handle circular wrapping - always show 5 cards around current
                  if (relativeIndex > 2) {
                    relativeIndex -= imageCasino.length;
                  }
                  if (relativeIndex < -2) {
                    relativeIndex += imageCasino.length;
                  }

                  const isVisible = Math.abs(relativeIndex) <= 2;

                  if (!isVisible) return null;

                  const handleCardClick = () => {
                    if (isActive) {
                      // Chỉ card ở giữa mới có thể click vào game
                      handleClick(e);
                    } else {
                      // Card bên trái/phải sẽ dịch chuyển slider
                      setCurrentSlide(index);
                    }
                  };

                  return (
                    <div
                      key={index}
                      className={`casino-card ${isActive ? "active" : ""} ${
                        relativeIndex === -2
                          ? "left-2"
                          : relativeIndex === -1
                            ? "left-1"
                            : relativeIndex === 1
                              ? "right-1"
                              : relativeIndex === 2
                                ? "right-2"
                                : ""
                      }`}
                      onClick={handleCardClick}
                      style={{ order: relativeIndex }}
                    >
                      <div className="card-pedestal">
                        <div className="card-frame">
                          <img
                            src={e.url}
                            alt={e.name}
                            className="card-image w-18 h-18 sm:w-22 sm:h-22 md:w-26 md:h-26 lg:w-30 lg:h-30 xl:w-34 xl:h-34 object-contain hover:brightness-110 hover:scale-105 hover:drop-shadow-[0_0_15px_rgba(255,255,255,0.6)] transition-all duration-500 ease-in-out cursor-pointer"
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Dots navigation */}
            <div className="flex justify-center mt-2 sm:mt-6 md:mt-8 space-x-2 sm:space-x-3">
              {imageCasino.map((_, index) => (
                <button
                  key={index}
                  className={`w-4 h-2 sm:w-6 sm:h-2 rounded-full transition-all duration-300 ${
                    currentSlide === index
                      ? "bg-[#00B2FF] scale-125"
                      : "bg-[#172EA2] hover:bg-[#00B2FF]"
                  }`}
                  onClick={() => setCurrentSlide(index)}
                />
              ))}
            </div>

            {/* Navigation Buttons */}
            <div className="flex items-center justify-between md:mt-0 mt-6 px-2 sm:px-4 md:px-8 max-w-full">
              <button
                className="flex items-center space-x-2 hover:opacity-80 transition-opacity"
                onClick={goToPreviousSlide}
              >
                <img
                  src="/assets/common/btn-back.png"
                  alt="Back"
                  className="md:w-auto w-2/3"
                />
              </button>

              <button
                className="flex items-center justify-end space-x-2 hover:opacity-80 transition-opacity"
                onClick={goToNextSlide}
              >
                <img
                  src="/assets/common/btn-next.png"
                  alt="Next"
                  className="md:w-auto w-2/3"
                />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Maintenance Modal */}
      {showMaintenance && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg p-4 sm:p-6 md:p-8 max-w-sm sm:max-w-md mx-4 text-center">
            <div className="text-4xl sm:text-6xl mb-3 sm:mb-4">🔧</div>
            <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 text-gray-800">
              Đang Bảo Trì
            </h3>
            <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">
              Hệ thống đang được bảo trì. Vui lòng thử lại sau!
            </p>
            <button
              onClick={() => setShowMaintenance(false)}
              className="bg-blue-500 hover:bg-blue-600 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg transition-colors text-sm sm:text-base"
            >
              Đóng
            </button>
          </div>
        </div>
      )}
      {/* LEFT BTN */}
      <div className="hidden md:block fixed bottom-28 left-14">
        <SocialButton />
      </div>
    </div>
  );
};

export default HomeCasino;
